import type {
  StaffingChangeSummary,
  StaffingHireReference,
  StaffingOrganization,
} from '../operations/model';

export const fixtureOrganizations: StaffingOrganization[] = [
  { id: 'root', name: '한결', subtitle: '대표이사 CEO · 지주회사', manager: '정성진', managerId: '01', count: 1, location: '서울 본사' },
  { id: 'product', parentId: 'root', name: 'Product Division', subtitle: '제품 부문', manager: '윤서연', count: 36, location: '서울 본사' },
  { id: 'engineering', parentId: 'root', name: 'Engineering Division', subtitle: '엔지니어링 부문', manager: '우디(박진우)', managerId: '02', count: 12, location: '서울 본사' },
  { id: 'platform', parentId: 'engineering', name: 'Platform Engineering Team', subtitle: '플랫폼 엔지니어링 팀', manager: '이도현', count: 16, location: '서울 본사' },
  { id: 'business', parentId: 'root', name: 'Business Division', subtitle: '비즈니스 부문', manager: '김서영', count: 61, location: '제주 지점' },
  { id: 'people', parentId: 'root', name: 'People & Culture', subtitle: '인사문화실', manager: '이정연', count: 38, location: '서울 본사' },
];

export const fixtureLocations: StaffingHireReference[] = [
  { id: 'location-seoul', descriptor: '서울 본사' },
  { id: 'location-jeju', descriptor: '제주 지점' },
  { id: 'location-gyeongbuk', descriptor: '경북 지점' },
];

export const fixtureJobs: StaffingHireReference[] = [
  { id: 'job-backend', descriptor: 'Backend Engineer' },
  { id: 'job-product', descriptor: 'Product Manager' },
  { id: 'job-design', descriptor: 'Product Designer' },
  { id: 'job-people', descriptor: 'HR Operations' },
];

export const fixtureJobLevels: StaffingHireReference[] = [
  { id: 'job-level-l3', descriptor: 'L3' },
  { id: 'job-level-l4', descriptor: 'L4' },
];

export const fixtureJobTypes: Record<'EMPLOYEE' | 'CONTINGENT_WORKER', StaffingHireReference[]> = {
  EMPLOYEE: [
    { id: 'job-type-regular', descriptor: '정규직' },
    { id: 'job-type-fixed-term', descriptor: '기간제' },
  ],
  CONTINGENT_WORKER: [
    { id: 'job-type-contractor', descriptor: '용역' },
    { id: 'job-type-freelancer', descriptor: '프리랜서' },
  ],
};

export const fixtureWorkSpaces: Record<string, StaffingHireReference[]> = {
  'location-seoul': [
    { id: 'work-space-seoul-4f', descriptor: '4층 Engineering Zone' },
    { id: 'work-space-seoul-5f', descriptor: '5층 Product Zone' },
  ],
};

export const initialFixtureChanges: StaffingChangeSummary[] = [
  {
    id: 'change-draft', descriptor: '김민서 조직·직무 변경', processType: 'JOB_CHANGE',
    subject: { id: '03', descriptor: '김민서' }, worker: { id: '03', descriptor: '김민서' },
    effectiveDate: '2026-09-15', status: 'DRAFT', createdAt: '2026-08-25T02:30:00Z',
    changes: [
      { field: 'organization', label: '소속 조직', before: 'Product Division', after: 'Platform Engineering Team' },
      { field: 'businessTitle', label: '직함', before: 'Product Manager', after: 'Product Operations Lead' },
    ],
  },
  {
    id: 'change-1', descriptor: '박준호 입사', processType: 'HIRE',
    subject: { id: 'person-1', descriptor: '박준호' }, person: { id: 'person-1', descriptor: '박준호' },
    effectiveDate: '2026-09-01', status: 'IN_PROGRESS', createdAt: '2026-08-15T00:00:00Z', submittedAt: '2026-08-15T00:10:00Z',
    changes: [
      { field: 'status', label: '재직 상태', before: '등록 전', after: '재직' },
      { field: 'organization', label: '소속 조직', before: '-', after: 'Engineering Division' },
    ],
  },
  {
    id: 'change-2', descriptor: '우디(박진우) 조직 변경', processType: 'JOB_CHANGE',
    subject: { id: '02', descriptor: '우디(박진우)' }, worker: { id: '02', descriptor: '우디(박진우)' },
    effectiveDate: '2026-09-01', status: 'COMPLETED', createdAt: '2026-08-14T00:00:00Z', submittedAt: '2026-08-14T00:10:00Z', completedAt: '2026-08-15T00:00:00Z',
    changes: [
      { field: 'organization', label: '소속 조직', before: 'Engineering Division', after: 'Product Division' },
      { field: 'businessTitle', label: '직함', before: 'Engineering Director', after: 'VP of Product Engineering' },
    ],
  },
  {
    id: 'change-3', descriptor: '장우진 퇴직', processType: 'END_WORKER',
    subject: { id: '07', descriptor: '장우진' }, worker: { id: '07', descriptor: '장우진' },
    effectiveDate: '2026-08-31', status: 'IN_PROGRESS', createdAt: '2026-08-13T00:00:00Z', submittedAt: '2026-08-13T00:10:00Z',
    changes: [{ field: 'status', label: '재직 상태', before: '재직', after: '종료' }],
  },
  {
    id: 'change-4', descriptor: '이수연 휴직', processType: 'LEAVE_OF_ABSENCE',
    subject: { id: '04', descriptor: '이수연' }, worker: { id: '04', descriptor: '이수연' },
    effectiveDate: '2026-08-01', status: 'COMPLETED', createdAt: '2026-07-10T00:00:00Z', submittedAt: '2026-07-10T00:10:00Z', completedAt: '2026-07-11T00:00:00Z',
    changes: [{ field: 'status', label: '재직 상태', before: '재직', after: '휴직' }],
  },
];
